import { useLang } from "../contexts/LanguageContext";

export default function Methodology() {
  const { t } = useLang();
  return (
    <section id="methodology" className="section-pad bg-cb-dark text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.08]" style={{ backgroundImage: "radial-gradient(circle at 20% 20%, #D4AF37 0, transparent 50%)" }} />
      <div className="container-cb relative">
        <div className="max-w-3xl">
          <div className="overline mb-4 flex items-center gap-3 text-cb-gold"><span className="gold-divider" /> {t.method.overline}</div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold">{t.method.title}</h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.method.steps.map((s, i) => (
            <div key={i} className="relative p-7 rounded-2xl border border-white/10 bg-white/[0.03]" data-testid={`method-step-${i}`}>
              <div className="text-cb-gold text-sm tracking-widest font-semibold" style={{ fontFamily: "Outfit" }}>{s.n}</div>
              <h3 className="mt-3 text-2xl font-semibold" style={{ fontFamily: "Outfit" }}>{s.t}</h3>
              <p className="mt-3 text-sm text-white/70 leading-relaxed">{s.d}</p>
              {i < t.method.steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -end-3 w-6 h-px bg-cb-gold/40" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
